import cardBackUrl from '../assets/images/card-back.png?url'
import tableFeltUrl from '../assets/images/table-felt.png?url'
import suitHeartUrl from '../assets/images/suit-heart.png?url'
import suitDiamondUrl from '../assets/images/suit-diamond.png?url'
import suitClubUrl from '../assets/images/suit-club.png?url'
import suitSpadeUrl from '../assets/images/suit-spade.png?url'

export class AssetManager {
	private static loaded = false

	private static readonly assets = {
		cardBack: cardBackUrl,
		tableFelt: tableFeltUrl,
		suitHearts: suitHeartUrl,
		suitDiamonds: suitDiamondUrl,
		suitClubs: suitClubUrl,
		suitSpades: suitSpadeUrl,
	} as const

	static get isLoaded() {
		return this.loaded
	}

	static getImageUrl(alias: keyof typeof AssetManager.assets) {
		return this.assets[alias]
	}

	static async loadAll(onProgress?: (progress: number) => void) {
		if (this.loaded) {
			onProgress?.(1)
			return
		}

		const entries = Object.values(this.assets)
		let completed = 0

		await Promise.all(
			entries.map(
				(src) =>
					new Promise<void>((resolve) => {
						const image = new Image()
						image.onload = () => {
							completed += 1
							onProgress?.(completed / entries.length)
							resolve()
						}
						image.onerror = () => {
							completed += 1
							onProgress?.(completed / entries.length)
							resolve()
						}
						image.src = src
					}),
			),
		)

		this.loaded = true
		onProgress?.(1)
	}
}
